// Copyright ©️ 2026 eVolve MEP, LLC

import { hasLengthExactly } from 'helpers/helper-types';

export const replaceSpaceToDash = (str: string | null | undefined) => {
  if (!str) return '';
  return str.replace(/\s+/g, '-').toLowerCase();
};

export const stringListToNaturalLanguage = (list: string[]) => {
  if (hasLengthExactly(list, 0)) return '';
  if (hasLengthExactly(list, 1)) return list[0];
  if (hasLengthExactly(list, 2)) return `${list[0]} and ${list[1]}`;

  return `${list.slice(0, -1).join(', ')}, and ${list[list.length - 1]}`;
};
